// import { createRouterReducer, createRouterReducerMapObject } from "@lagunovsky/redux-react-router";
import { getReduxKey } from "@fla/common";
import { combineReducers } from "@reduxjs/toolkit";
import { TConsentOrdersActions, consentOrdersReducer, consentOrdersReducerName } from "pages/ConsentOrders";
import { TGetStartedActions, getStartedReducer, getStartedReducerName } from "pages/GetStarted/getStartedSlice";
import { TUserActions, userReducer, userReducerName } from "pages/User";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import pkg from "../../package.json";

// import { history } from "utils";

const userPersistConfig = {
  key: getReduxKey(pkg.name, "user"),
  storage: storage,
  blacklist: ["status", "error", "userCreatedInSession"]
};

// const routerReducer = createRouterReducer(history);
const rootReducer = combineReducers({
  // ...createRouterReducerMapObject(history),
  user: persistReducer(userPersistConfig, userReducer),
  getStarted: getStartedReducer,
  consentOrders: consentOrdersReducer
});

export type AppActions = TUserActions | TGetStartedActions | TConsentOrdersActions;

export type StateSlices = typeof userReducerName | typeof getStartedReducerName | typeof consentOrdersReducerName;

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
